
import '../CSS/Background.css';

/**
 * Temas disponibles para el fondo animado:
 *   default    → cubos cyan
 *   christmas  → Papá Noel y reno  (todo diciembre)
 *   halloween  → calabaza y fantasma (31 oct)
 *   colombia   → chiva, bandera y cumbia (20 jul y 7 ago)
 *
 * Para forzar un tema agrega ?theme= a la URL:
 *   http://localhost:3000/?theme=christmas
 *   http://localhost:3000/?theme=halloween
 *   http://localhost:3000/?theme=colombia
 *   http://localhost:3000/?theme=default
 */

const imgChristmas = [
  require('../Images/christmas/cara-de-papa-noel.png'),
  require('../Images/christmas/reno.png'),
];
const imgHallowen = [
  require('../Images/hallowen/calabaza.png'),
  require('../Images/hallowen/fantasma.png'),
];
const imgColombia = [
  require('../Images/colombia/chiva.png'),
  require('../Images/colombia/colombia.png'),
  require('../Images/colombia/cumbia.png'),
];

const THEME_IMAGES = {
  christmas: imgChristmas,
  halloween: imgHallowen,
  colombia:  imgColombia,
};

function getActiveTheme() {
  const params  = new URLSearchParams(window.location.search);
  const forced  = params.get('theme');
  const themes  = ['default', 'christmas', 'halloween', 'colombia'];
  if (forced && themes.includes(forced)) return forced;

  const now   = new Date();
  const month = now.getMonth() + 1;
  const day   = now.getDate();

  if (month === 12) return 'christmas';
  if (month === 10 && day === 31) return 'halloween';
  if ((month === 8 && day === 7) || (month === 7 && day === 20)) return 'colombia';
  return 'default';
}

const ITEMS = 10;

function Background_app() {
    const theme  = getActiveTheme();
    const images = THEME_IMAGES[theme] ?? null;

    return (
        <div className="Background">
            <ul className={`circles theme-${theme}`}>
                {Array.from({ length: ITEMS }, (_, i) => (
                    <li key={i}>
                        {images && (
                            <img
                                src={images[i % images.length]}
                                alt=""
                                aria-hidden="true"
                                className="bg-theme-img"
                            />
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default Background_app;
